import Vue from 'vue'

import 'carbon-components/css/carbon-components.css'

import CarbonComponentsVue from '@carbon/vue'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(CarbonComponentsVue)

export default function createPage (mainView, data = {}) {
  Vue.component('mainView', mainView)
  return new Vue({
    render: h => h(App),
    data: {
      mainView,
      ...data
    }
  }).$mount('#app')
}
